// extracted by mini-css-extract-plugin
module.exports = {"header":"ValidatorCompact_header__2W7Iq","vertical":"ValidatorCompact_vertical__3Xaad","moniker":"ValidatorCompact_moniker__2N9J5","footer":"ValidatorCompact_footer__1pr3C"};